export default __webpack_public_path__ + "static/media/info-green.49300365.svg";